let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("9zLwF"), load("9PoiB")]).then(() => parcelRequire('f6GYX'));